import React, { Suspense, useEffect } from 'react';
// importing  Routes ;
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';


// Helmet Provider;

import { HelmetProvider } from 'react-helmet-async';

// importing Redux components
import { Provider } from 'react-redux';
import { store } from 'redux-api/store';

// Hotjar
import Hotjar from '@hotjar/browser';

//// import components
import {
  Home,
  DetailCourse,
  VacancyResume,
  Vacancies,
  AboutUs,
  FAQ,
  Advantages,
  MapSite,
  News,
  NewsDetails,
  AllCourse,
  InfoAboutDevs,
  NotFound,
  Privacy,
  CareerCenter,
  SignIn,
  SignUp,
  PasswordRecovery,
  Direction,
  Students,
  Student,
  GeeksJunior,
  AfterCoursesPage,
  EditStudent,
  CookiesPolicy,
  CryptoCourse,
  BinanceGeeks,
  BinanceScenario,
} from 'pages/index.js';
import { Layout } from 'components/Base/index.js';
import Loader from 'components/Loader/Loader.js';
import { message } from 'antd';
import { GoogleOAuthProvider } from '@react-oauth/google';

/// importing MUI components

// всплывающие уведомления antd в тёмной теме
import 'mainStyle/notifications.scss';

// import theme from 'theme';
import theme from './mainStyle/theme.js';
import { PATHS, GOOGLE_CLIENT_ID } from './common/constants.js';
import { hideAppPreloader } from './common/helpers.js';

// importing scss
import './mainStyle/global.scss';


// Уведомления — под шапкой; длительность совпадает с полоской-таймером в notifications.scss.
message.config({ top: 104, duration: 3.5, maxCount: 3 });

const siteID = 3671181;
const hotjarVersion = 6;

Hotjar.init(siteID, hotjarVersion);

const App = () => {
  const location = useLocation();

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const isLightPage = location.pathname === PATHS.privacy;
    document.getElementById('root').style.background = isLightPage ? 'none' : '';
    document.documentElement.classList.toggle('is-light-page', isLightPage);

    // Главная сама убирает прелоадер, когда загрузит данные; остальные страницы — сразу.
    if (location.pathname !== PATHS.main) hideAppPreloader();
    scrollTop();
    return () => null;
  }, [ location ]);

  const helmetContext = {};
  return (
    <>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ThemeProvider theme={theme}>
            <HelmetProvider context={helmetContext}>
              <CssBaseline />
              <Routes>
                <Route loader={<Loader/>} element={<Layout/>}>
                  <Route index path={PATHS.main} element={<Home />} />
                  <Route path={PATHS.vacancies} element={<Vacancies />} />
                  <Route path={PATHS.vacancyResume} element={<VacancyResume />} />
                  <Route path={PATHS.detailCourse} element={<DetailCourse />} />
                  <Route path={PATHS.detailTechnology} element={<InfoAboutDevs />} />
                  <Route path={PATHS.mapSite} element={<MapSite />}/>
                  <Route path={PATHS.news} element={<News />}/>
                  <Route path={PATHS.newsDetails} element={<NewsDetails />}/>
                  <Route path={PATHS.afterCourses} element={<AfterCoursesPage/>}/>
                  <Route path={PATHS.cryptoCourse} element={<CryptoCourse />} />
                  {/* Страница доступа объединена с /crypto-course, старый адрес редиректит */}
                  <Route
                    path={PATHS.cryptoCourseAccess}
                    element={<Navigate to={PATHS.cryptoCourse} replace />}
                  />
                  {/* Geeks junior */}
                  <Route path={PATHS.geeksJunior} element={<GeeksJunior />} />
                </Route>
                <Route loader={<Loader/>} element={<Layout/>}>
                  <Route path={PATHS.allcourses} element={<AllCourse />} />
                  <Route path={PATHS.aboutUs} element={<AboutUs />} />
                  <Route path={PATHS.FAQ} element={<FAQ />} />
                  <Route path={PATHS.advantages} element={<Advantages />} />
                  {/* Geeks PRO */}
                  <Route path={PATHS.careerCenter} element={<CareerCenter />} />
                  <Route path={PATHS.signIn} element={<SignIn />} />
                  <Route path={PATHS.signUp} element={<SignUp />} />
                  <Route path={PATHS.passwordRecovery} element={<PasswordRecovery />} />
                  <Route path={PATHS.direction} element={<Direction />} />
                  <Route path={PATHS.students} element={<Students />} />
                  <Route path={PATHS.student} element={<Student />} />
                  <Route path={PATHS.editStudent} element={<EditStudent />} />
                  <Route path={PATHS.cookiesPolicy} element={<CookiesPolicy />} />
                </Route>
                <Route loader={<Loader/>}>
                  <Route path={PATHS.privacy} element={<Privacy />} />
                  {/* У лендингов своя шапка по макету, поэтому они вне Layout.
                      Своя граница Suspense нужна каждому: она монтируется
                      вместе с маршрутом, и переход по клику не роняет ошибку. */}
                  <Route
                    path={PATHS.binanceGeeks}
                    element={
                      <Suspense fallback={<Loader />}>
                        <BinanceGeeks />
                      </Suspense>
                    }
                  />
                  <Route
                    path={PATHS.binanceScenario}
                    element={
                      <Suspense fallback={<Loader />}>
                        <BinanceScenario />
                      </Suspense>
                    }
                  />
                </Route>
                <Route path='*' element={<NotFound />} />
              </Routes>
            </HelmetProvider>
          </ThemeProvider>
        </GoogleOAuthProvider>
      </Provider>
    </>
  );
};

export default App;
